import React from "react";
import logo from "../../assets/images/indicator-icon.svg";

const ManageChartsLogo = props => (
  <img className={props.className} src={logo} alt="manage" />
);

export default ManageChartsLogo;
